import { WidgetDataType } from '../models/types.js';
import ContentBlockDefaultRequest from './contentBlock.js';
import PreviewSearchDefaultRequest from './previewSearch.js';
import QuestionsDefaultRequest from './questions.js';
import RecommendationDefaultRequest from './recommendation.js';
import SearchResultsDefaultRequest from './searchResults.js';
const DEFAULTS = {
    [WidgetDataType.RECOMMENDATION]: RecommendationDefaultRequest,
    [WidgetDataType.SEARCH_RESULTS]: SearchResultsDefaultRequest,
    [WidgetDataType.PREVIEW_SEARCH]: PreviewSearchDefaultRequest,
    [WidgetDataType.QUESTIONS]: QuestionsDefaultRequest,
    [WidgetDataType.CONTENT_BLOCK]: ContentBlockDefaultRequest,
    [WidgetDataType.HTML_BLOCK]: ContentBlockDefaultRequest,
    [WidgetDataType.SEO]: ContentBlockDefaultRequest,
    [WidgetDataType.BANNER]: ContentBlockDefaultRequest,
};
const getDefaultRequestFor = (type, rfkId) => {
    if (DEFAULTS[type]) {
        return DEFAULTS[type](rfkId);
    }
    throw new Error(`Invalid widget type: "${type}"`);
};
export { getDefaultRequestFor };
